import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./loginSlice";
import globalSlice from "./globalSlice";
import customerGroupSetupSlice from "../pages/Setup/Customer/customerGroupSetupSlice";
// import productGroupSetupSlice from "../pages/Setup/Product/productGroupSetupSlice";
import scenarioSetupNewSlice from "../pages/Setup/Scenario/scenarioSetupNewSlice";
import editScenarioNewSlice from "../pages/Setup/Scenario/Edit/editScenarioNewSlice";
import analyzeSlice from "../pages/Analyze/analyzeSlice";
import scenarioApprovalSlice from "../pages/Approval/Scenario/scenarioApprovalSlice";
import quotaModificationApprovalSlice from "../pages/Approval/QuotaModification/quotaModificationApprovalSlice";
import quotaApprovalSlice from "../pages/Approval/Quota/quotaApprovalSlice";
// import cgpgSlice from "../pages/Approvals/cGPg/cgpgSlice";
import reviewSlice from "../pages/Review/reviewSlice";
import dashboardSlice from "../pages/Dashboard/dashBoardSlice";
import defineSlice from "../pages/Define/defineSlice";
import quotaCopySlice from "../pages/Define/quotaCopySubmit/quotaCopySlice";
import functionalAdminSlice from "../pages/Functionaladmin/functionalAdminSlice";
import centralAdminSlice from "../pages/Admin/centralAdminSlice";
import fileTransferSlice from "../pages/FileTransfer/fileTransferSlice";
import auditSlice from "../pages/Audit/auditSlice";

export const store = configureStore({
	reducer: {
		login: loginSlice,
		global: globalSlice,
		dashboard: dashboardSlice,
		customerGroupSetup: customerGroupSetupSlice,
		// productGroupSetup: productGroupSetupSlice,
		scenarioSetupNew: scenarioSetupNewSlice,
		editScenarioNew: editScenarioNewSlice,
		analyze: analyzeSlice,
		fileTransfer: fileTransferSlice,
		scenarioApproval: scenarioApprovalSlice,
		quotaModification: quotaModificationApprovalSlice,
		quota: quotaApprovalSlice,
		// cgpgApproval: cgpgSlice,
		review: reviewSlice,
		define: defineSlice,
		quotaCopy: quotaCopySlice,
		functionAdmin: functionalAdminSlice,
		centralAdmin: centralAdminSlice,
		audit:auditSlice
	},
});
